import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useTheme } from "../../Context/ThemeContext";
import { lightTheme, darkTheme } from "../../Styles/theme";

import TeacherBox from "./TeacherBox";

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

export default function TeacherSelectBox(props) {
  const { teachers, selectedTeachers, setSelectedTeachers } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClickedSelectBox, setIsClickedSelectBox] = useState(false);
  const [coachSelectBoxHeight, setCoachSelectBoxHeight] = useState(0);

  const TopLevelRef = useRef();

  // 선택창 크기 계산 //
  useEffect(() => {
    if (teachers.length > 5) setCoachSelectBoxHeight(155);
    else setCoachSelectBoxHeight(teachers.length * 32);
  }, [teachers])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      setIsClickedSelectBox(false);
    }
  }

  function onClickTeacherBox(data) {
    const selectedIndex = selectedTeachers.findIndex((teacher) => teacher.teacherId === data.teacherId);

    if (selectedIndex === -1) setSelectedTeachers([...selectedTeachers, data]);
    else setSelectedTeachers(selectedTeachers.filter((_, index) => index !== selectedIndex));
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SelectView
        buttonPath={isClickedSelectBox ? SelectOnPath : SelectOffPath}
        isClicked={isClickedSelectBox}
        onClick={() => setIsClickedSelectBox(!isClickedSelectBox)}>
        <SelectedCoachBoxWrapper>
          {
            selectedTeachers.map((data, index) => (
              index < 3 &&
              <SelectedCoachBox key={'SelectedTeacher-' + index}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} cursor='pointer'>{index < 2 ? data.teacherName : '+ ' + (selectedTeachers.length - 2)}</Text>
              </SelectedCoachBox>
            ))
          }
        </SelectedCoachBoxWrapper>
      </SelectView>
      <CoachSelectBox isClicked={isClickedSelectBox} height={isClickedSelectBox ? coachSelectBoxHeight : 0}>
        {
          teachers.map((data, index) => (
            <TeacherBox
              key={'TeacherBox-' + index}
              data={data}
              index={index}
              isLast={teachers.length === (index + 1)}
              isClicked={selectedTeachers.some((teacher) => teacher.teacherId === data.teacherId)}
              onClickTeacherBox={onClickTeacherBox} />
          ))
        }
      </CoachSelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const SelectView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 5px;

  width: calc(100% - 12px);
  height: calc(100% - 2px);

  border: 1px solid ${props => props.theme.line};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: ${props => props.isClicked ? `0px` : `5px`};
  border-bottom-right-radius: ${props => props.isClicked ? `0px` : `5px`};

  background: url(${props => props.buttonPath}) no-repeat 99% ${props => props.isClicked ? `3` : `55`}%;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SelectedCoachBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 80%;

  gap: 8px;
`;

const SelectedCoachBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  height: 26px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CoachSelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 32px;

  width: calc(100% - 2px);
  height: ${props => props.height}px;

  border-left: 1px solid ${props => props.theme.line};
  border-right: 1px solid ${props => props.theme.line};
  border-bottom: ${props => props.isClicked ? `1px solid ${props.theme.line}` : `0px`};
  border-bottom-left-radius: ${props => props.isClicked ? `5px` : `0px`};
  border-bottom-right-radius: ${props => props.isClicked ? `5px` : `0px`};

  background-color: ${props => props.theme.subBackground};
  z-index: 10;

  overflow-x: hidden;
  overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.line};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;